<ng-container *ngIf="(isLoggedIn$ | async)">
  <nz-layout class="app-layout">
    <nz-sider class="menu-sidebar" nzWidth="256px" nzBreakpoint="md" nzCollapsible [(nzCollapsed)]="isCollapsed" [nzTrigger]="null">
      <app-menu-aside></app-menu-aside>
    </nz-sider>
    <nz-layout>
      <nz-header>
        <app-menu-header class="col-12" [isCollapsed]="isCollapsed"></app-menu-header>
      </nz-header>
      <nz-content>
        <div class="ps-3 pb-2">
          <nz-breadcrumb [nzAutoGenerate]="true" [nzSeparator]="iconTemplate" class="fw-semibold"></nz-breadcrumb>
          <ng-template #iconTemplate>
            <span class="pt-2 solar--alt-arrow-right-line-duotone"></span>
          </ng-template>
        </div>
        <div class="px-4 pb-5 pt-0 scroll h-100">
          <router-outlet></router-outlet>
        </div>
      </nz-content>
    </nz-layout>
  </nz-layout>
</ng-container>

<ng-container *ngIf="!(isLoggedIn$ | async)">
  <nz-layout class="app-layout">
    <ng-container>
      <div class="row m-0 p-0">
        <div class="col-12 d-flex align-items-start justify-content-center formulario h-100 scroll">
          <div class="row d-flex align-items-start justify-content-center my-4 pt-3">
            <router-outlet></router-outlet>
          </div>
        </div>
        <div class="bg-overlay">
          <img src="./assets/images/login/seriella-background-img.jpeg" class="bg-image" />
        </div>
      </div>
    </ng-container>
  </nz-layout>
</ng-container>
<footer class="footer-versao">
  <span>Versão {{ versaoApp }}</span>
</footer>
<div
  *ngIf="!isProd"
  class="tarja-aviso-nao-producao"
  role="status"
  aria-live="polite"
>
  AMBIENTE NÃO-PRODUÇÃO — USE APENAS PARA TESTES
</div>
<app-loader></app-loader>
